export default "__VITE_ASSET__BYqXXCZX__"